export const MAPBOX_STYLE_LIGHT = "mapbox://styles/mapbox/streets-v12";
export const MAPBOX_STYLE_DARK = "mapbox://styles/mapbox/navigation-night-v1";

export function getAfriMedMapStyle(isDark = false) {
  return isDark ? MAPBOX_STYLE_DARK : MAPBOX_STYLE_LIGHT;
}
